module.exports = __webpack_public_path__ + "img/login-he.e1f913c6.png";